



















































































































































































































import Vue from 'vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import { Sponsor } from '@/models/sponsor';
import { truncate, isPlainObject, cloneDeep } from 'lodash';
import { isEmptyObject } from '@/utils/helpers';
export default Vue.extend({
  metaInfo() {
    return {
      title: 'Sponsor'
    };
  },
  data: () => ({
    editMode: false,
    edit: null as any,
    category: {
      name: '',
      priority: '',
      event: localStorage.getItem('current__event')
    }
  }),
  computed: {
    ...mapState({
      categories: (state: any) => state.sponsors.categories,
      sponsorsCategoryOptions: (state: any) =>
        state.sponsors.sponsorsCategoryOptions,
      sponsorsLoading: (state: any) => state.sponsors.sponsorsLoading,
      error: (state: any) => state.sponsors.error
    })
  },
  methods: {
    isEmptyObject,
    truncate,
    cloneDeep,

    ...mapActions({
      fetchCategories: 'sponsors/fetchCategories',
      optionsCategory: 'sponsors/optionsCategory',
      createCategory: 'sponsors/createCategory',
      updateCategory: 'sponsors/updateCategory',
      deleteCategory: 'sponsors/deleteCategory',
      clearError: 'sponsors/clearError'
    }),
    async addCategory(category: any) {
      console.log({ category }, 'category');

      category.event = localStorage.getItem('current__event');

      await this.createCategory(category).then(() => {
        this.category = {
          name: '',
          priority: '',
          event: localStorage.getItem('current__event')
        };
      });
    },
    async editCategory(category: any) {
      console.log(category);

      await this.updateCategory(category).then(res => {
        this.edit = res;
      });
    },

    setForm(payload: any) {
      console.log(payload);

      const data = new FormData();
      function iterate(payload: any) {
        for (const key in payload) {
          const value = payload[key];
          if (isPlainObject(value)) {
            let keyName;
            for (const nestedKey in value) {
              keyName = [key, '.', nestedKey].join('');
              data.append(keyName, value[nestedKey]);
            }
          } else if (value != null) {
            data.append(key, value);
          }
        }
      }
      iterate(payload);
      // data.append('event', localStorage.getItem('current__event') || '');
      console.log(data);
      return data;
    }
  },
  watch: { $route: 'fetchCategories' },
  async mounted() {
    await this.$nextTick();
    await this.optionsCategory();
    await this.fetchCategories({
      event: localStorage.getItem('current__event')
    });
  }
});
